import "./SurveyCardComponent.scss";

import { Segment } from "@fluentui/react-northstar";
import { ScheduleDTO, SurveyDTO } from "@teams/types/api";
import React from "react";

import { useUserInfo } from "../../../../_shared/actions/useUserInfo";
import { QuizLeaderboard } from "../../Meetings/components/quiz/QuizLeaderboard";
import { PollDetailsComponent } from "./PollDetailsComponent";
import { SurveyDetailsComponent } from "./SurveyDetailsComponent";
import { SurveyFooterComponent } from "./SurveyFooterComponent";
import { SurveyHeaderComponent } from "./SurveyHeaderComponent";

type Props = {
  survey: SurveyDTO;
  schedule?: ScheduleDTO;
  onChanged: (id: string) => void;
};

export const SurveyCardComponent: React.FC<Props> = ({ survey, schedule, onChanged }) => {
  const { user } = useUserInfo();

  if (!user) {
    return null;
  }

  return (
    <Segment className="surveyCard" color="brand">
      <SurveyHeaderComponent survey={survey} />
      {survey.type === "poll" ? (
        <PollDetailsComponent survey={survey} />
      ) : survey.type === "quiz" && survey.state === "closed" ? (
        <QuizLeaderboard
          survey={survey}
          responses={survey.responses!}
          hidePointTotal={true}
          maxDisplay={5}
        />
      ) : (
        <SurveyDetailsComponent applicationType={survey.applicationType} />
      )}
      <SurveyFooterComponent
        survey={survey}
        schedule={schedule}
        onChanged={() => onChanged(survey.id as string)}
      />
    </Segment>
  );
};
